module.exports = __webpack_public_path__ + "img/Mbuylogo.c4b0ae43.svg";